import {useMutation, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {
	bindSelfEmploymentPartner,
	type BindSelfEmploymentPartnerRequest,
	type BindSelfEmploymentPartnerResponse,
} from '../../http';

export function useBindSelfEmploymentPartner(
	options?: UseMutationOptions<BindSelfEmploymentPartnerResponse, unknown, BindSelfEmploymentPartnerRequest>,
): UseMutationResult<BindSelfEmploymentPartnerResponse, unknown, BindSelfEmploymentPartnerRequest> {
	return useMutation<BindSelfEmploymentPartnerResponse, unknown, BindSelfEmploymentPartnerRequest>(
		(request) => bindSelfEmploymentPartner(request).then(({data}) => data),
		options,
	);
}
